<template>
  <div class="main-content">
    <Nav></Nav>
    <div class="center-body">
      <div class="row">
        <!-- <div class="item" style="align-items: center;">
          <span
            style="font-size: 18px;color: #333;cursor: pointer;"
            @click="change"
          >
            {{ $t("lang.filter") }}
            <Icon type="ios-arrow-forward" v-show="!isFilter" /><Icon
              type="ios-arrow-down"
              v-show="isFilter"
            />
          </span>
        </div> -->
        <Breadcrumb separator=">">
          <BreadcrumbItem to="/">{{ $t("lang.product") }}</BreadcrumbItem>
          <BreadcrumbItem>{{ $t("lang.productcenter") }}</BreadcrumbItem>
        </Breadcrumb>
        <!-- <div class="item" style="align-items: center;">
          {{ $t("lang.product") }}
          >
          {{ $t("lang.productcenter") }} -->
        <!-- <Button @click="goback">{{ $t("lang.back") }}</Button> -->
        <!-- </div> -->
      </div>
      <Form
        label-width="120"
        :model="formItem"
        style="margin-top: 30px;"
        label-position="left"
        v-if="isFilter"
      >
        <div class="row">
          <div class="item" style="flex: 2;">
            <FormItem :label="$t('lang.proname')" style="width: 668px;">
              <Select
                v-model="formItem.protype"
                clearable
                @on-clear="getProductSet"
                @on-select="changeOption"
                style="width: 540px;"
                filterable
              >
                <Option
                  v-for="option in options"
                  :value="option.id"
                  :key="option.id"
                  >{{ option.name }}</Option
                >
              </Select>
            </FormItem>
            <Button
              type="primary"
              style="margin-left: 40px; margin-top: 1px;"
              @click="getpagePro"
              >{{ $t("lang.search") }}
            </Button>
          </div>
          <div class="item" style="flex: 3;"></div>
        </div>
        <div class="filter" v-if="isSelect">
          <div class="row">
            <div class="item" style="flex: 2;">
              <FormItem :label="$t('lang.pull')">
                <!-- <Row> -->
                <!-- <Col span="18"> -->
                <i-Input
                  v-model="formItem.llName"
                  style="width: 200px;"
                  @on-keydown="initSlider('pull')"
                  @on-change="changePage2(1)"
                ></i-Input>
                <!-- </Col>
                  <Col span="4"> -->
                <Select
                  v-model="formItem.select"
                  style="width: 100px; margin-left: 5px;"
                  @change="selectChange"
                >
                  <Option value="lb">LB</Option>
                  <Option value="kg">KG</Option>
                </Select>
                <!-- </Col>
                </Row> -->

                <!--                <i-Input v-model="formItem.llName" style="width: 200px;"></i-Input>-->
              </FormItem>
            </div>
            <div class="item" style="flex: 3;">
              <el-slider
                v-if="formItem.select === 'lb'"
                v-model="formItem.ll"
                style="width: 100%;"
                :min="0"
                :max="12"
                :marks="marks1"
                show-stops
                :format-tooltip="formatLBtip"
                @change="lbSliderChange"
              ></el-slider>
              <el-slider
                v-if="formItem.select === 'kg'"
                v-model="formItem.ll"
                style="width: 100%;"
                :min="0"
                :max="20"
                :marks="marks4"
                show-stops
                :format-tooltip="formatKGtip"
                @change="kgSliderChange"
              ></el-slider>
            </div>
          </div>
          <div class="row">
            <div class="item" style="flex: 2;">
              <FormItem :label="$t('lang.length')">
                <i-Input
                  v-model="formItem.lonName"
                  style="width: 200px;"
                  @on-keydown="initSlider('long')"
                  @on-change="changePage2(1)"
                ></i-Input>
                mm
              </FormItem>
            </div>
            <div class="item" style="flex: 3;">
              <el-slider
                v-model="formItem.lon"
                style="width: 100%;"
                :min="0"
                :max="46"
                :marks="marks2"
                show-stops
                :format-tooltip="formatLontip"
                @change="lonSliderChange"
              ></el-slider>
            </div>
          </div>
          <div class="row">
            <div class="item" style="flex: 2;">
              <FormItem :label="$t('lang.width')">
                <i-Input
                  v-model="formItem.widthName"
                  style="width: 200px;"
                  @on-keydown="initSlider('width')"
                  @on-change="changePage2(1)"
                ></i-Input>
                mm
              </FormItem>
            </div>
            <div class="item" style="flex: 3;">
              <el-slider
                v-model="formItem.width"
                style="width: 100%;"
                :min="0"
                :max="16"
                :marks="marks3"
                show-stops
                :format-tooltip="formatWidthtip"
                @change="widthSliderChange"
              ></el-slider>
            </div>
          </div>
        </div>
      </Form>

      <div class="prduct-box">
        <div class="wrap-row" style="margin-bottom: 15px;">
          <div
            class="col-no"
            style="width: 23%; margin: 15px 1% 0 1%;"
            v-for="(set, index) in productSet"
            :key="index"
            @click="toDetail(set)"
          >
            <template v-if="productSet.length > 0">
              <template v-if="name">
                <div
                  style="
                  width: 100%;
                  height: 270px;
                  justify-content: center;
                  display: flex;
                  align-items: center;
                  overflow: hidden;
                "
                >
                  <img :src="set.pic" style="width: 100%; height: 270px;" />
                </div>
                <div
                  class="item"
                  style="
                  justify-content: center;
                  font-size: 14px;
                  color: #333;
                  font-weight: 400;
                  margin-top: 10px;
                "
                >
                  {{ set.name }}
                </div>
              </template>
              <template v-else>
                <template v-if="index > 7">
                  <div
                    style="
                  width: 100%;
                  height: 270px;
                  justify-content: center;
                  display: flex;
                  align-items: center;
                  overflow: hidden;
                "
                  >
                    <img :src="set.pic" style="width: 100%; height: 270px;" />
                  </div>
                  <div
                    class="item"
                    style="
                  justify-content: center;
                  font-size: 16px;
                  color: #333;
                  margin-top: 10px;
                "
                  >
                    {{ set.name }}
                  </div>
                </template>
              </template>
            </template>
          </div>
          <div
            class="col-no"
            style="width: 23%; margin: 15px 1% 0 1%;"
            v-for="list in data"
            :key="list.id"
            @click="toSpecialDetail(list.id)"
          >
            <template v-if="productSet.length <= 0">
              <div
                style="
                  width: 100%;
                  height: 270px;
                  justify-content: center;
                  display: flex;
                  align-items: center;
                  overflow: hidden;
                "
              >
                <img :src="list.pic" style="width: 100%; height: 270px;" />
              </div>
              <div
                class="item"
                style="
                  justify-content: center;
                  font-size: 16px;
                  color: #333;
                  margin-top: 10px;
                "
              >
                {{ list.code }}
              </div>
            </template>
          </div>
        </div>
      </div>

      <div
        class="row"
        style="justify-content: center; margin: 15px 0px;"
        v-if="productSet.length <= 0"
      >
        <template>
          <Page
            v-show="isALl"
            :page-size="pageSize"
            :total="total"
            :current="current"
            @on-change="changePage1"
            show-total
          ></Page>
          <Page
            v-show="!isALl"
            :page-size="pageSize"
            :total="total"
            :current="current"
            @on-change="changePage2"
            show-total
          ></Page>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./nav.vue";

export default {
  name: "App",
  components: {
    Nav,
  },
  data() {
    return {
      name: "",
      productSet: [],
      isFilter: true,
      isSelect: false,
      qproductId: "",
      formItem: {
        llName: "",
        ll: "",
        lon: "",
        lonName: "",
        widthName: "",
        width: "",
        select: "lb",
      },
      LBList: [0, 15, 18, 40, 45, 50, 75, 120, 123, 175, 250, 253, 700],
      KGList: [
        0,
        6.8,
        8.1,
        8.16,
        18.14,
        18.2,
        20.4,
        22.2,
        34.02,
        34.2,
        40,
        50,
        54.4,
        68.04,
        79.4,
        113.4,
        114,
        120,
        150,
        175,
        317,
      ],
      widthList: [
        0,
        2.5,
        3.6,
        3.8,
        4.3,
        4.6,
        4.8,
        7.2,
        7.6,
        7.9,
        9.0,
        10,
        12,
        12.5,
        12.7,
        13.2,
        16,
      ],
      lonList: [
        0,
        60,
        80,
        100,
        110,
        112,
        120,
        150,
        155,
        158,
        160,
        170,
        173,
        178,
        189,
        200,
        204,
        205,
        215,
        220,
        225,
        250,
        275,
        280,
        300,
        304,
        350,
        370,
        380,
        400,
        450,
        500,
        530,
        550,
        650,
        750,
        760,
        800,
        890,
        900,
        920,
        1000,
        1100,
        1200,
        1230,
        1300,
        1500,
      ],
      total: 0,
      isALl: true,
      current: 1,
      pageSize: 12,
      marks1: {
        0: "0",
        12: "700LB",
      },
      marks2: {
        0: "0",
        46: "1500mm",
      },
      marks3: {
        0: "0",
        16: "16mm",
      },
      marks4: {
        0: "0",
        20: "317KG",
      },
      options: [],
      data: [],
    };
  },
  watch: {
    $route(to, from) {
      this.name = to.query.productName || "";
      this.getProductSet();
    },
  },
  methods: {
    goback() {
      history.back();
    },
    initSlider(type){
      if(type === 'pull'){
        this.formItem.ll = 0;
      }else if(type === 'long'){
        this.formItem.lon = 0;
      }else if(type === 'width'){
        this.formItem.width = 0;
      }
    },
    change() {
      this.isFilter = !this.isFilter;
    },
    toDetail(item) {
      this.$util.toClassify(item);
      this.$router.push("classify");
    },
    toSpecialDetail(id) {
      this.$localstorage.setStore("specialId", id);
      this.$localstorage.setStore("detail_productId", this.qproductId);
      this.$router.push("detail");
    },
    changePage1(c) {
      window.scrollTo(0,0);
      this.current = c;
    },
    changePage2(c) {
      window.scrollTo(0,0);
      this.current = c;
      this.getpagePro();
    },
    selectChange() {
      if (this.formItem.select === "lb") {
        this.formItem.ll = 0;
      } else {
        this.formItem.ll = 0;
      }
    },
    getpagePro() {
      let self = this;
      let formData = {};
      let form = [];
      self.qproductId = this.formItem.protype;
      if (!self.qproductId) {
        self.$toast("请选择品名");
        return;
      }
      self.productSet = [];
      if (self.isSelect) {
        if (this.formItem.select === "kg") {
          form.push({ key: "mlk", equal: this.formItem.llName });
        } else if (this.formItem.select === "lb") {
          form.push({ key: "mll", equal: this.formItem.llName });
        }
        form.push({ key: "ll", equal: this.formItem.lonName });
        form.push({ key: "ww", equal: this.formItem.widthName });
      }
      formData = {
        productId: self.qproductId,
        specialQuery: form,
        size: 12,
        current: this.current,
      };
      this.$api.api
        .pageProSpecial(JSON.stringify(formData))
        .then(function(response) {
          if (response.data.code === 200) {
            self.data = response.data.data.records;
            self.total = response.data.data.total;
            self.isALl = false;
          } else {
            self.$toast(response.data.msg);
          }
        });
    },
    changeOption(option) {
      let self = this;
      let item = {};
      item = self.$lodash.find(self.options, function(o) {
        return o.id === option.value;
      });
      if (item.type === 20) {
        self.isSelect = true;
        if (item.type === 20) {
          self.isSelect = true;
        }
        this.current = 1;
      } else {
        this.$util.toClassify(item);
        this.$router.push("classify");
      }
    },

    //获取产品系列
    getProductSet() {
      let self = this;
      this.$api.api.listAllProLike(self.name).then(function(response) {
        if (response.data.code === 200) {
          self.data = [];
          var products = [];
          response.data.data.forEach((product) => {
            if (product.type !== 47) {
              products.push(product);
            }
          });
          self.productSet = products;
        } else {
          self.$toast(response.data.msg);
        }
      });
    },
    getSelect() {
      let self = this;
      this.$api.api.listAllPro().then(function(response) {
        if (response.data.code === 200) {
          self.data = [];
          var products = [];
          response.data.data.forEach((product) => {
            if (product.type !== 47) {
              products.push(product);
            }
          });
          self.options = products;
        }
      });
    },

    // LB格式化
    formatLBtip(val) {
      let self = this;
      return self.LBList[val] ? self.LBList[val] : "";
      // self.formItem.llName = self.LBList[val] ? self.LBList[val] : '';
      // return self.formItem.llName;
    },
    //
    //KG格式化
    formatKGtip(val) {
      let self = this;
      return self.KGList[val] ? self.KGList[val] : "";
      // self.formItem.llName = self.KGList[val] ? self.KGList[val] : '';
      // return self.formItem.llName;
    },
    //长度格式化
    formatLontip(val) {
      let self = this;
      return self.lonList[val] ? self.lonList[val] : "";
      // return self.formItem.lonName;
    },
    //宽度格式化
    formatWidthtip(val) {
      let self = this;
      return self.widthList[val] ? self.widthList[val] : "";
      // self.formItem.widthName = self.widthList[val] ? self.widthList[val] : '';
      // return self.formItem.widthName;
    },

    lbSliderChange(val) {
      let self = this;
      self.formItem.llName = self.LBList[val] ? self.LBList[val] : "";
    },

    kgSliderChange(val) {
      let self = this;
      self.formItem.llName = self.KGList[val] ? self.KGList[val] : "";
    },

    lonSliderChange(val) {
      let self = this;
      self.formItem.lonName = self.lonList[val] ? self.lonList[val] : "";
    },

    widthSliderChange(val) {
      let self = this;
      self.formItem.widthName = self.widthList[val] ? self.widthList[val] : "";
    },
  },
  mounted() {
    this.name = this.$route.query.productName || "";
    this.getProductSet();
    this.getSelect();
  },
};
</script>
<style>
/* .ivu-form .ivu-form-item-label{
  text-align: left;
} */
</style>
<style scoped>
.main-content {
  min-height: 100%;
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
  display: block;
  position: absolute;
  background: #fff;
  margin-top: 135px;
}

.center-body {
  width: 1200px;
  margin: 30px auto 0;
}

.prduct-box {
  margin: 0px -15px;
  padding: 15px 0;
}
</style>
<style>
.filter .ivu-form-item {
  width: 425px;
}
.el-slider__button-wrapper{
	z-index: 50 !important;
}
</style>
